// JQuery init
$(document).ready(function () {
	// 產品tabs 切換, 滾至 tabs頂部
	$('.product-tabs .tabs-link').on('click', function () {
		var tabsTop = $('#product-tabs-anchor').offset().top;
		var headerHeight = $('.hd').height();
		headerHeight = headerHeight > 68 ? 68 : headerHeight; // 桌機版 header 往下滾會縮小，高度以縮小後的為準

		$('html, body')
			.stop()
			.animate({ scrollTop: tabsTop - headerHeight }); // 扣除 header 高度
	});
});

// 產品縮圖 swiper
var productThumbsSwiper = new Swiper('#product-thumbs-swiper .swiper-container', {
	slidesPerView: 3,
	spaceBetween: 10,
	freeMode: true,
	watchSlidesProgress: true,
	grabCursor: true,
	// navigation: {
	// 	nextEl: '#product-thumbs-swiper .swiper-button-next',
	// 	prevEl: '#product-thumbs-swiper .swiper-button-prev',
	// },
	breakpoints: {
		640: {
			slidesPerView: 4,
		},
		768: {
			slidesPerView: 3,
		},
		1024: {
			slidesPerView: 4,
		},
		1200: {
			slidesPerView: 5,
		},
	},
});

// 產品大圖 swiper
var productImgSwiper = new Swiper('#product-img-swiper .swiper-container', {
	slidesPerView: 1,
	spaceBetween: 10,
	thumbs: {
		swiper: productThumbsSwiper,
	},
	navigation: {
		nextEl: '#product-thumbs-swiper .swiper-button-next',
		prevEl: '#product-thumbs-swiper .swiper-button-prev',
	},
});

// 更多產品 swiper
var moreProductSwiper = new Swiper('#more-product-swiper .swiper-container', {
	slidesPerView: 2,
	spaceBetween: 16,
	navigation: {
		nextEl: '#more-product-swiper .swiper-button-next',
		prevEl: '#more-product-swiper .swiper-button-prev',
	},
	breakpoints: {
		640: {
			slidesPerView: 2,
			spaceBetween: 20,
		},
		768: {
			slidesPerView: 3,
			spaceBetween: 20,
		},
		1200: {
			slidesPerView: 4,
			spaceBetween: 30,
		},
		1440: {
			slidesPerView: 4,
			spaceBetween: 50,
		},
	},
});

/* ---------------------------------------- [START] Copy link */
function buildClipboardJS() {
	if (window.ClipboardJS !== undefined) {
		var clipboard = new ClipboardJS('.js-copy-link', {
			text: function (trigger) {
				var text = window.location.href;
				return text;
			},
		});

		clipboard.on('success', function (e) {
			e.clearSelection();
			e.trigger.blur();
		});
	}
}
window.addEventListener('load', buildClipboardJS);
/* ---------------------------------------- [END] Copy link */